import React, {useState,useEffect} from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import CalendarComponent from "../../React_Components/CalendarComponen";
import TrackerButtons from "../Tracker_Common/TrackerButtons";
import { FaEdit, FaTrash } from 'react-icons/fa'; // React Icons for edit
import RemainderModal from "../Tracker_Common/Remainder";
import { useNavigate } from "react-router-dom";
import { Endpoints } from "../../../Global/Endpoints";
import { useTranslation } from 'react-i18next';
import SyncMiraDevice from "../../Mira/SyncMiraDeviceModal";
import ErrorModal from "../../Security/ErrorModal";
import { toast } from "react-toastify";

const Menopause = ()=>{
    const { t, i18n } = useTranslation();
    const [selectedDate,setSelectedDate] = useState(new Date());
    const [currentMonth,setCurrentMonth] = useState(new Date());
    const email = useSelector((state)=>state.email.email);
    const userInfo = useSelector((state) => state.userData);
    const [remainders, setRemainders] = useState([]);
    const [notes,setNotes] = useState([]);
    const [isModalOpen, setModalOpen] = useState(false);
    const [miraConsent, setMiraConsent] = useState(null);
    const [showSyncMiraDevice, setShowSyncMiraDevice] = useState(false);
    const navigate = useNavigate()
    const [menopauseData,setMenopauseData] = useState({currentCycle: [], nextCycle: [],monthCycle: []});
    const [editData, setEditData] = useState(null);
    const [reminderList,setReminderList] = useState([]);
    const token = localStorage.getItem("AccessToken");
    const ssoData = useSelector((state) => state.sso.ssoUserData);
    const isHighmarkPortal = ssoData?.Portal === "Highmark";
    const deviceType = isHighmarkPortal ? "HighmarkPortal" : "PatientPortal";
    const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] = useState(false);
  const [deletingReminder, setDeletingReminder] = useState(null);
    
    const fetchMenstrualCycleData = async (date)=>{
        const currentDate = date.toLocaleDateString("en-US");
        const params = { EmailID: email, Date: currentDate, DeviceType:deviceType };

        try{
            const response = await axios.post(
                Endpoints.LoadMenstrualCycleCalendarData,
                `_Params=${encodeURIComponent(JSON.stringify(params))}`,
                {
                    headers : {
                        "Content-Type" : "application/x-www-form-urlencoded",
                        Authorization : `Bearer ${token}`,
                    },
                }
            );

            if(response.data){
              setRemainders(response.data.ReminderDate ? response.data.ReminderDate.split(",") : []);
                setNotes(response.data.EventDate ? response.data.EventDate.split(",") : []);

                const parseCycleData = (cycleString) => {
                  // Split the string into an array of dates
                  const dates = cycleString ? cycleString.split(",") : [];
                  // Check if there are dates to set start and end
                  if (dates.length > 0) {
                      return [{ start: dates[0], end: dates[dates.length - 1] }];
                  }
                  return [];
              };
 
              setMenopauseData({
                currentCycle: parseCycleData(response.data.CurrentCycle),
                nextCycle: parseCycleData(response.data.NextCycle),
                monthCycle: parseCycleData(response.data.MonthlyCycle)
            });
            }
        }catch(error){
            console.log(t('errormenstrual'),error)
        }

    };

    const fetchReminders = async (date) => {
      const formattedDate = date.toLocaleDateString("en-US");
      const params = { EmailID: email, Date: formattedDate,DeviceType:deviceType };
  
      try {
        const response = await axios.post(
          Endpoints.LoadReminderEventData,
          `_Params=${encodeURIComponent(JSON.stringify(params))}`,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${token}`,
            },
          }
        );
  
        if (response.data && response.data.Reminders) {
          const mappedReminders = response.data.Reminders.map(reminder => ({
            ReminderID: reminder.ReminderID,
            ReminderTitle: reminder.ReminderTitle,
            StartTime: new Date(reminder.StartTime), // Ensure this is a Date object
            EndTime: new Date(reminder.EndTime), // Ensure this is a Date object
          }));
          setReminderList(mappedReminders);
        }
      } catch (error) {
        console.error(t('errorreminders'), error);
      }
    };

    useEffect(() => {
          if (typeof window !== "undefined") {
          window.resetCalendarGlobals?.();
        }
        }, []);

    useEffect(() => {
    const fetchMiraConsent = async () => {
      if (!email || !userInfo?.userData.AppUserId) return;
      const params = { EmailID: email, AppUserId: userInfo.userData.AppUserId, DeviceType: deviceType, TrackerType: "Manopause Tracker" };
      try {
        const response =  await axios.post(
          Endpoints.LoadMiraDataSyncConsent,
          `_Params=${encodeURIComponent(JSON.stringify(params))}`,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data) {
          setMiraConsent(response.data);
          if (!response.data.Consent || !response.data.Consent.trim()) {
              // setShowMiraModal(true);
            } else if (response.data.Consent === "O") {
              // hide mira button
            }
        }
      } catch (error) {
        console.error("Error fetching Mira Data Sync Consent:", error);
      }
    };
    fetchMiraConsent();
}, [email, userInfo?.userData.AppUserId]);
   
    useEffect(() => {
      fetchMenstrualCycleData(currentMonth);
      fetchReminders(selectedDate);
    }, [currentMonth, selectedDate, email, token]);

    useEffect(() => {
      fetchReminders(selectedDate);
    }, [selectedDate, email, token]);

    const handleMiraButtonClick = () => {
      setShowSyncMiraDevice(true);
    };

    const handleModalClose = () => {
      fetchMenstrualCycleData(currentMonth);
      fetchReminders(selectedDate);
    };  
    const handleDateSelect = (date) => {
      setSelectedDate(date);
    };


    const handleMonthChange = (firstDayOfMonth) => {
      setCurrentMonth(firstDayOfMonth);
    };

  const handleEditClick = (reminder) => {
    console.log(selectedDate)
    if(selectedDate >= new Date() || selectedDate.toDateString() === new Date().toDateString())
    {
      setEditData({
        isEdit: true,
        reminderId: reminder.ReminderID,
        reminderDate: selectedDate
      });
      setModalOpen(true);
    }
  };

  const handleDeleteClick = (reminder) => {
      setDeletingReminder(reminder);
      setShowDeleteConfirmationModal(true);
  };

  const confirmDelete = async () => {
      setShowDeleteConfirmationModal(false);

      if (!deletingReminder?.ReminderID) return;

      const payload = {
        ReminderID: deletingReminder.ReminderID,
        EmailID: email,
        DeviceType: deviceType,
      };

      try {
        const response = await axios.post(
          Endpoints.DeleteReminder,
          `_Params=${encodeURIComponent(JSON.stringify(payload))}`,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data?.Result === "1") {
          setTimeout(() => {
            toast.success(t("reminderdeletemessage"));
          }, 500);
          setReminderList(prev =>
            prev.filter(r => r.ReminderID !== deletingReminder.ReminderID)
          );
        } else {
          toast.error("Failed to delete reminder");
        }
      } catch (error) {
        console.error(error);
        toast.error("An error occurred while deleting the reminder.");
      } finally {
        setDeletingReminder(null);
      }
    };

   // Check for valid reminders
   const hasValidReminders = reminderList.some(reminder => 
    reminder.ReminderID && reminder.ReminderTitle && reminder.StartTime && reminder.EndTime
  );
    const getConfig = ()=>({
        type: "menopause",
        cycleData:menopauseData,
        onDateSelect: handleDateSelect,
    onMonthChange: handleMonthChange,
    remainders,
    notes,

    });
    const handleBackClick = () => {
      navigate(-1); // Redirects to the home page
    };
    const closeModal = () => {
      setModalOpen(false);
      setEditData(null);
      handleModalClose();
    };

    const ispastDate=selectedDate < new Date()
    const istoday=selectedDate.toDateString() === new Date().toDateString()
    const isfutureDate=selectedDate > new Date()
  
    return(
        <>

          {isHighmarkPortal ? 
            <div className="col-md-12 col-lg-6 mt-4 d-flex inner-page-heading-wrapper">
            <button className="win-back-btn" onClick={handleBackClick}>
                <span>
                <i className="bi bi-chevron-left"></i>
                </span>
            </button>       
            <h2 className="page-heading">{t('menopauselabel')}</h2>
            </div>:
            <div className="col-md-12 col-lg-6 mt-4 d-flex inner-page-heading-wrapper">
            <button className="win-back-btn" onClick={handleBackClick}>
                <span>
                <i className="bi bi-chevron-left"></i>    
                {t('Back')}        
                </span>
            </button>       
            <h2 className="page-heading">{t('menopauselabel')}</h2>
            </div>
          }

          {/* <div className="col-md-12 col-lg-6 mt-4 inner-page-heading-wrapper">
            <button className="win-back-btn win-back-btn-2line-heading-mobile-view" onClick={handleBackClick}><span><i class='bi bi-chevron-left'></i> {t('backbutton')}</span></button>
            <h2 className="page-heading">{t('menopauselabel')}</h2>
          </div> */}
      <div className="col-md-12 col-lg-6 mt-4 mt-md-0 d-flex justify-content-end flex-sm-row flex-column align-items-center menopause-tracker-buttons-wrapper mb-5">
        <TrackerButtons
          isPastDate={selectedDate < new Date()}
          isToday={selectedDate.toDateString() === new Date().toDateString()}
          isFutureDate={selectedDate > new Date()}
          trackerType="menopause"
          selectedDate={selectedDate}
          onCloseModalCallback={handleModalClose}
          showEditCycle={true} /* No Edit Cycle for Pregnancy */
          onMiraClick={handleMiraButtonClick}
          isEditMode={true}
          showTrends={false} /* Show Trends for Pregnancy */
        />
      </div>

      <div className="col-md-8 col-lg-6 mt-md-4">
            <CalendarComponent config = {getConfig()} />
        </div>
        <div className="col-md-12 col-lg-6 mt-3 mt-md-4">
        <h3 className="page-heading-bold remainders-heading">{t('reminderlabel')}</h3>
        <div className="reminders-wrapper mt-3 mt-md-3 menopause-tracker-remainders">
          {hasValidReminders ? (
            reminderList.sort((a, b) => a.StartTime - b.StartTime).map((reminder, index) => (
              <div key={index} className="reminder-card">
                <h4 className="reminder-appointment-name">{reminder.ReminderTitle}</h4>
                <h4 className="reminder-appointment-datetime">{t('startdate')} {(() => {
                  // Format date as mm/dd/yyyy
                  const dateObj = reminder.StartTime;
                  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
                  const date = String(dateObj.getDate()).padStart(2, '0');
                  const year = dateObj.getFullYear();
                  const formattedDate = `${month}/${date}/${year}`;
                  // Check if time is 00:00:00
                  const hours = dateObj.getHours();
                  const minutes = dateObj.getMinutes();
                  const seconds = dateObj.getSeconds();
                  if (hours === 0 && minutes === 0 && seconds === 0) {
                    // Show only date
                    return formattedDate;
                  } else {
                    // Show date and time
            const formattedTime = dateObj.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });                    
                    return `${formattedDate}, ${formattedTime}`;
                  }
                })()}</h4>
                  <FaEdit onClick={() => handleEditClick(reminder)} className="reminder-edit-icon" />
                  <FaTrash onClick={() => handleDeleteClick(reminder)} className="reminder-delete-icon" />
              </div>
            ))
          ) : (
            <div className="no-reminders-set">{t('noreminderslable')}</div>
          )}
        </div>
      </div>
      <RemainderModal 
        isOpen={isModalOpen} 
        onClose={closeModal} 
        reminderId={editData?.reminderId} 
        reminderDate={editData?.reminderDate} 
        isEdit={editData?.isEdit} 
        onSave={() => fetchReminders(selectedDate)}
      />

      <SyncMiraDevice 
        isOpen={showSyncMiraDevice}
        onClose={() => setShowSyncMiraDevice(false)}
        email={email}
        userInfo={userInfo}
        deviceType={deviceType}
        miraConsent={miraConsent?.Consent}
        miraLoginURL={miraConsent?.MiraLoginURL}
        token={token}
        serviceDescription={"Menopause"}
      />
      <ErrorModal
        show={showDeleteConfirmationModal}
        onClose={() => setShowDeleteConfirmationModal(false)}
        showConfirmButtons={true}
        message={"Are you sure you want to delete this reminder?"}
        onOkay={confirmDelete}
      />
        </>
    );
    

};
export default Menopause;